import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a6708fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2a6708fe&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2a6708fe&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6708fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6708fe')) {
      api.createRecord('2a6708fe', component.options)
    } else {
      api.reload('2a6708fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a6708fe&scoped=true", function () {
      api.rerender('2a6708fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/publicPayModal/index.vue"
export default component.exports